import { useNavigate } from "react-router";
import "./login.css";
import qs from "qs";
import store from "../../app/store/store";
import { setMobile, stopLoading, setUserDetail } from "../../app/store/reducer";
import { encrypt } from "../../utils/encryption";
import Swal from "sweetalert2";
import { LoginApi, getOtp } from "./loginApi";
import { swalAlertPopProps } from "../../utils/commonUtils";
import { ENCRYPTIONKEY } from "../../utils/api";
import { routePath } from "../../constants/routePath";
import React, { useEffect, useState } from "react";
import {
  TextField,
  Box,
  Button,
  Typography,
  Container,
  Grid,
  Card,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ElegantLogo from "../../assets/elegantPrimeLogo.png";
import { GetUserApi } from "../../utils/utils";
import { loginValidation } from "../login/loginValidationFunction";

export default function AssistantLogin() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userDetail = useSelector((state) => state.reducer.userDetail);

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const [mobileNumber, setMobileNumber] = useState("");
  const [loginData, setLoginData] = useState({
    username: "",
    grant_type: "implicit",
    client_id: "client",
    ismpinauth: "1",
    mpin: "",
    password: "",
    loggedinweb: "0",
  });

  // Generate random string for encryption
  function generateRandomString(length) {
    const chars = "0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      result += chars[randomIndex];
    }
    return result;
  }

  // Handle OTP input changes
  const handleChange = (value, index) => {
    let newOtp = [...otp];
    if (/^[0-9]?$/.test(value)) {
      newOtp[index] = value;
      setOtp(newOtp);
    }
  };

  // Check if token exists and redirect accordingly
  const checkTokenORReset = async () => {
    const val = await sessionStorage.getItem("smbToken");
    if (val) {
      if (userDetail?.appMenu) {
        // navigate(userDetail.appMenu !== "Biller" ? routePath.FAV : routePath.DASHBOARD);
      }
    }
  };

  useEffect(() => {
    checkTokenORReset();
  }, []);

  // Handle OTP input navigation
  const handleKeyUp = (e, index) => {
    const nextInput = document.querySelector(`input[name=otp${index + 1}]`);
    const prevInput = document.querySelector(`input[name=otp${index - 1}]`);

    if (e.key === "Backspace" && prevInput) {
      prevInput.focus();
    } else if (nextInput && e.target.value !== "") {
      nextInput.focus();
    }
  };

  // Handle forget MPIN functionality
  const handleForgetMPINClick = () => {
    if (mobileNumber.length !== 10) {
      Swal.fire({
        text: "Please Enter Phone Number",
        icon: "warning",
        ...swalAlertPopProps,
      });
    } else {
      const obj = { ...loginData };
      const randomId = Math.floor(Math.random() * 10000)
        .toString()
        .padStart(4, "0");
      obj.username = encrypt(mobileNumber + randomId, ENCRYPTIONKEY);
      obj.password = encrypt(otp.join("") + randomId, ENCRYPTIONKEY);

      getOtp({ Mobile: obj.username }, (res) => {
        dispatch(setMobile(obj.username));
        navigate("/otpforget");
      });
    }
  };

  // Handle login submission
  const handleSubmit = async () => {
    const val = loginValidation({
      ...loginData,
      username: mobileNumber,
      password: otp.join(""),
    });

    // if (!val?.status) {
    //   Swal.fire({
    //     title: val.title,
    //     text: val.text,
    //     icon: "warning",
    //     ...swalAlertPopProps,
    //   });
    //   return;
    // }

    const obj = { ...loginData,
      associate:"1", 
     };
    const randomId = Math.floor(Math.random() * 10000)
      .toString()
      .padStart(4, "0");
    obj.username = encrypt(mobileNumber + randomId, ENCRYPTIONKEY);
    obj.password = encrypt(otp.join("") + randomId, ENCRYPTIONKEY);

    try {
      const loginTmp = qs.stringify(obj);
      const loginResponse = await LoginApi(loginTmp);

      await sessionStorage.setItem(
        "smbToken",
        loginResponse?.data?.access_token
      );

      const userResponse = await GetUserApi();
      const userData = { ...userResponse.data.data };
      navigate(routePath.DASHBOARD);

      // Dispatch user details to Redux store

      if (userData.appMenu) {
        if (userData.appMenu != "Biller") {
          dispatch(setUserDetail(userData));

          navigate(routePath.FAV);
        } else {
          Swal.fire({
            title: "Incorrect User",
            icon: "error",
            ...swalAlertPopProps,
          });
        }
        // navigate(userData.appMenu !== "Biller" ? routePath.FAV : routePath.DASHBOARD);
      } else {
        Swal.fire({
          title: "This user is Assistant",
          icon: "success",
          ...swalAlertPopProps,
        });
      }
    } catch (err) {
      if (err?.response?.status === 400) {
        Swal.fire({
          title: "Invalid Username or Password",
          text: "Please enter a valid username and password",
          icon: "error",
          ...swalAlertPopProps,
        });
        dispatch(stopLoading());
      }
    }
  };

  // Handle Enter key press
  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSubmit();
    }
  };

  return (
    <Container maxWidth="lg" sx={{ padding: { xs: "10px", sm: "20px" } }}>
      <Card
        sx={{
          padding: { xs: "10px", sm: "20px" },
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          background:
            "linear-gradient(90deg, #EBEAFF 0%, #C3C3F8 36.54%, #7E7EEB 59.13%, #01008B 100%)",
          boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
          borderRadius: "14px",
          mt: { sm: 1, xs: 1, md: 2, lg: 3 },

          height: "70vh",
        }}
      >
        <Grid
          container
          alignItems="center"
          spacing={{ xs: 1, sm: 1, md: 1, lg: 2 }}
          sx={{ height: "100%", flex: 1 }}
        >
          <Grid
            item
            xs={12}
            md={7}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Grid
              container
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Grid item xs={6}>
                <Box
                  component="img"
                  src={ElegantLogo}
                  alt="Elegant Logo"
                  sx={{
                    width: { xs: "200px", sm: "250px", md: "350px" },
                  }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
                backgroundColor: "#fff",
                borderRadius: "20px",
                padding: "20px",
              }}
            >
              <Typography
                variant="h4"
                gutterBottom
                sx={{
                  color: "#01008B",
                  fontWeight: 600,
                  textAlign: "center",
                  fontSize: { xs: 20, sm: 25, md: 30 },
                }}
              >
                Log In
              </Typography>

              <TextField
                label="User ID"
                type="tel"
                value={mobileNumber}
                onChange={(e) => setMobileNumber(e.target.value)}
                sx={{ mb: 2, width: { xs: "100%", sm: "22.3rem" } }}
                inputProps={{
                  maxLength: 10,
                  inputMode: "numeric",
                  pattern: "[0-9]*",
                  sx: { fontSize: { xs: "12px", sm: "14px", md: "18px" } },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: { xs: "12px", sm: "14px", md: "18px" },
                  },
                }}
                onKeyPress={handleKeyPress}
                variant="outlined"
              />

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                  width: { xs: "100%", sm: "20rem" },
                  mb: 1,
                }}
              >
                <Typography
                  sx={{
                    color: "#01008B",
                    fontWeight: 500,
                    fontSize: { xs: 13, sm: 14, md: 18 },
                  }}
                >
                  Enter MPIN
                </Typography>
              </Box>

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  gap: 2,
                  mb: { xs: 1, sm: 1, md: 1, lg: 2 },
                }}
              >
                {otp.map((value, index) => (
                  <TextField
                    key={index}
                    name={`otp${index}`}
                    type="text"
                    value={value}
                    onChange={(e) => handleChange(e.target.value, index)}
                    onKeyUp={(e) => handleKeyUp(e, index)}
                    inputProps={{
                      maxLength: 1,
                      inputMode: "numeric",
                      pattern: "[0-9]*",
                      style: { textAlign: "center", fontSize: "24px" },
                    }}
                    variant="standard"
                    margin="dense"
                    onKeyPress={handleKeyPress}
                    sx={{
                      width: { xs: "45px", sm: "65px" },

                      "& .MuiInput-underline:before": {
                        borderBottom: "3px solid #01008B",
                      },
                      "& .MuiInput-underline:after": {
                        borderBottom: "3px solid #01008B",
                      },
                      "& .MuiInputBase-input": { padding: 0, height: "35px" },
                    }}
                  />
                ))}
              </Box>

              <Button
                variant="contained"
                sx={{
                  backgroundColor: "#01008B",
                  cursor: "pointer",
                  fontSize: { xs: "12px", sm: "15px", md: "18px" },

                  fontWeight: "600",
                  marginTop: "10px",
                  width: { xs: "100%", sm: "22.3rem" },
                }}
                onClick={handleSubmit}
              >
                Log In
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Card>
    </Container>
  );
}
